var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row align-items-center profile-header"},[_c('PageSummary',{attrs:{"headline":"User Profile"}},[_c('p',[_vm._v(" Feel free to update your email preferences. ")])]),_c('UserProfile')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }